// @flow
import PlainTable from './PlainTable';

export default PlainTable;
